import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({providedIn:'root'})
export class SelfCheckinContextService {
  private names = new Map<string, {expires: number; value: Promise<string>}>();
  constructor(private http: HttpClient) {}

  name(tenant: string, kind: string, targetId: number): Promise<string> {
    const key = `${tenant}:${kind}:${targetId}`;
    const cached = this.names.get(key);
    if (cached && cached.expires > Date.now()) return cached.value;
    // Share concurrent lookups and cache public names briefly, per church.
    // A failure falls back to the category label and is retried on a future visit.
    const entry = {expires:Date.now() + 5 * 60 * 1000, value:null as Promise<string>};
    entry.value = this.http.get<{name:string}>(`${environment.apiHost}/Checkin/Context`,
      {params:{kind, targetId:targetId.toString()}}).toPromise().then(result => {
        const name = typeof result?.name === 'string' ? result.name.trim() : '';
        if (!name && this.names.get(key) === entry) this.names.delete(key);
        return name;
      }).catch(() => {
        if (this.names.get(key) === entry) this.names.delete(key);
        return '';
      });
    // Keep the cache bounded when many churches or links are visited.
    if (this.names.size >= 100) this.names.delete(this.names.keys().next().value);
    this.names.set(key, entry);
    return entry.value;
  }
}
